import PackageIndicator from './PackageIndicator';

export default PackageIndicator;
